/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Offerseyebrow1Inputs */

const id_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-dagang`)
};

const ms_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-dagang`)
};

const da_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-handel`)
};

const de_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Commerce`)
};

const en_us2_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const es_es2_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comercio electrónico`)
};

const es_mx2_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comercio electrónico`)
};

const fil_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const fr_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce électronique`)
};

const it_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const hu_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-kereskedelem`)
};

const nl_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const no_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-handel`)
};

const pl_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handel elektroniczny`)
};

const pt_br2_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comércio eletrônico`)
};

const pt_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comércio eletrónico`)
};

const ro_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comerț electronic`)
};

const fi_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkkokauppa`)
};

const sv_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-handel`)
};

const vi_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thương mại điện tử`)
};

const tr_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ticaret`)
};

const cs_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const bg_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Електронна търговия`)
};

const ru_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная коммерция`)
};

const uk_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Електронна комерція`)
};

const ar_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التجارة الإلكترونية`)
};

const hi_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ई-कॉमर्स`)
};

const th_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีคอมเมิร์ซ`)
};

const ja_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eコマース`)
};

const zh_cn2_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子商务`)
};

const zh_hant1_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子商務`)
};

const ko_sandboxes_offerseyebrow1 = /** @type {(inputs: Sandboxes_Offerseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이커머스`)
};

/**
* | output |
* | --- |
* | "E-commerce" |
*
* @param {Sandboxes_Offerseyebrow1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_offerseyebrow1 = /** @type {((inputs?: Sandboxes_Offerseyebrow1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Offerseyebrow1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_offerseyebrow1(inputs)
	if (locale === "ms") return ms_sandboxes_offerseyebrow1(inputs)
	if (locale === "da") return da_sandboxes_offerseyebrow1(inputs)
	if (locale === "de") return de_sandboxes_offerseyebrow1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_offerseyebrow1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_offerseyebrow1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_offerseyebrow1(inputs)
	if (locale === "fil") return fil_sandboxes_offerseyebrow1(inputs)
	if (locale === "fr") return fr_sandboxes_offerseyebrow1(inputs)
	if (locale === "it") return it_sandboxes_offerseyebrow1(inputs)
	if (locale === "hu") return hu_sandboxes_offerseyebrow1(inputs)
	if (locale === "nl") return nl_sandboxes_offerseyebrow1(inputs)
	if (locale === "no") return no_sandboxes_offerseyebrow1(inputs)
	if (locale === "pl") return pl_sandboxes_offerseyebrow1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_offerseyebrow1(inputs)
	if (locale === "pt") return pt_sandboxes_offerseyebrow1(inputs)
	if (locale === "ro") return ro_sandboxes_offerseyebrow1(inputs)
	if (locale === "fi") return fi_sandboxes_offerseyebrow1(inputs)
	if (locale === "sv") return sv_sandboxes_offerseyebrow1(inputs)
	if (locale === "vi") return vi_sandboxes_offerseyebrow1(inputs)
	if (locale === "tr") return tr_sandboxes_offerseyebrow1(inputs)
	if (locale === "cs") return cs_sandboxes_offerseyebrow1(inputs)
	if (locale === "bg") return bg_sandboxes_offerseyebrow1(inputs)
	if (locale === "ru") return ru_sandboxes_offerseyebrow1(inputs)
	if (locale === "uk") return uk_sandboxes_offerseyebrow1(inputs)
	if (locale === "ar") return ar_sandboxes_offerseyebrow1(inputs)
	if (locale === "hi") return hi_sandboxes_offerseyebrow1(inputs)
	if (locale === "th") return th_sandboxes_offerseyebrow1(inputs)
	if (locale === "ja") return ja_sandboxes_offerseyebrow1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_offerseyebrow1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_offerseyebrow1(inputs)
	return ko_sandboxes_offerseyebrow1(inputs)
});
export { sandboxes_offerseyebrow1 as "sandboxes.offersEyebrow" }